const mobileNavBreakpoint = 1100;

document.querySelectorAll('.site-header').forEach((header, index) => {
    const toggle = header.querySelector('.menu-toggle');
    const menu = header.querySelector('nav ul');
    const resourcesDropdown = header.querySelector('.nav-dropdown');
    const resourcesToggle = header.querySelector('.nav-dropdown-toggle');

    if (!toggle || !menu) return;

    if (!menu.id) {
        menu.id = `site-nav-menu-${index + 1}`;
    }

    toggle.setAttribute('aria-controls', menu.id);
    toggle.setAttribute('aria-expanded', 'false');

    const closeMenu = () => {
        menu.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        if (resourcesDropdown) {
            resourcesDropdown.classList.remove('open');
        }
        if (resourcesToggle) {
            resourcesToggle.setAttribute('aria-expanded', 'false');
        }
    };

    if (resourcesToggle && resourcesDropdown) {
        resourcesToggle.setAttribute('aria-expanded', 'false');
        resourcesToggle.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const isOpen = resourcesDropdown.classList.toggle('open');
            resourcesToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    }

    toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const isOpen = menu.classList.toggle('open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
            closeMenu();
        });
    });

    document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
            closeMenu();
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth > mobileNavBreakpoint) {
            closeMenu();
        }
    });
});

if (window.lucide) {
    window.lucide.createIcons();
}

document.querySelectorAll('.reveal').forEach((el) => {
    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in');
            }
        });
    }, { threshold: 0.15 });
    io.observe(el);
});

const year = document.getElementById('year');
if (year) year.textContent = new Date().getFullYear();

document.querySelectorAll('[data-count]').forEach((el) => {
    const target = Number(el.getAttribute('data-count'));
    if (!Number.isFinite(target)) return;

    let current = 0;
    const step = Math.max(1, Math.floor(target / 30));

    const tick = () => {
        current += step;
        if (current >= target) {
            el.textContent = String(target);
            return;
        }
        el.textContent = String(current);
        requestAnimationFrame(tick);
    };

    tick();
});

